import React, { FunctionComponent, useEffect, useState } from "react";
import { Fields, UnlimitedWidgets } from "@webtie-ch/form-widget-library";
import { Spinner } from "react-bootstrap";
import validator from "@rjsf/validator-ajv8";
import Form from "@rjsf/react-bootstrap";

import FormSchema from "../../models/schema/FormSchema";

/** Id des <form>-Elements — erlaubt einen Speichern-Button ausserhalb des Formulars. */
export const REGISTRATION_FORM_ID = "registration-editor-form";

interface Props {
  formSchema: FormSchema;
  formData: any;
  isSaving: boolean;
  onSubmit: (formData: any) => void;
  /** Eigene Id, falls mehrere Instanzen möglich sind (z.B. Drawer). */
  formId?: string;
  /** Aus, wenn der Absende-Button ausserhalb des Formulars sitzt. */
  showSubmitButton?: boolean;
}

const RegistrationEditor: FunctionComponent<Props> = ({
  formData: initialFormData,
  formSchema,
  isSaving,
  onSubmit,
  formId = REGISTRATION_FORM_ID,
  showSubmitButton = true
}: Props) => {
  const [formData, setFormData] = useState<any>(initialFormData);

  useEffect(() => {
    setFormData(initialFormData);
  }, [initialFormData]);

  return (
    <Form
      id={formId}
      validator={validator}
      formData={formData}
      onChange={(e: any) => setFormData(e.formData ?? {})}
      schema={formSchema.formSchema}
      uiSchema={formSchema.uiSchema}
      onSubmit={(e: any) => onSubmit(e.formData)}
      widgets={UnlimitedWidgets}
      fields={Fields}>
      {showSubmitButton ? (
        <button disabled={isSaving} type="submit" className="btn btn-primary">
          Speichern {isSaving && <Spinner size={"sm"} animation={"border"} />}
        </button>
      ) : (
        <></>
      )}
    </Form>
  );
};

export default RegistrationEditor;
